import React from 'react';
import { useNavigate } from 'react-router-dom';

const PaymentSuccess: React.FC = () => {
    const navigate = useNavigate();

    return (
        <div>
            <h1>Pagamento avvenuto con successo!</h1>
            <p>Grazie per il tuo acquisto.</p>
            <button onClick={() => navigate('/')}>Torna alla Home</button>
        </div>
    );
};

export default PaymentSuccess;